export const INTERNAL_ACCOUNT_TYPE = 'internalAccount';
export const PAYMENT_SYSTEM_TYPE = 'paymentSys';
